import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemText,
  CssBaseline,
  Box,
  Collapse,
} from "@mui/material";
import appLogo from "../../assets/images/header-footer/app-logo.png";
import dashboard from "../../assets/images/dashboard/dashboard.png";
import customer from "../../assets/images/dashboard/customers.png";
import plans from "../../assets/images/dashboard/plans.png";
import themes from "../../assets/images/dashboard/themes.png";
// import domain from "../../assets/images/dashboard/domain.png";
// import content from "../../assets/images/dashboard/content.png";
import payment from "../../assets/images/dashboard/payment.png";
import dashboardActive from "../../assets/images/dashboard/dashboard-active.png";
import customersActive from "../../assets/images/dashboard/customers-active.png";
import plansActive from "../../assets/images/dashboard/plans-active.svg";
import themesActive from "../../assets/images/dashboard/themes-active.png";
// import domainActive from "../../assets/images/dashboard/domain-active.png";
// import contentActive from "../../assets/images/dashboard/content-active.png";
import paymentActive from "../../assets/images/dashboard/payment-active.png";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
// import i18next from "i18next";


const drawerWidth = 250;

const Sidebar = ({ contentNavigation }) => {
  const [expanded, setExpanded] = useState(null);
  const [activeItem, setActiveItem] = useState({
    parent: "Dashboard",
    child: null,
  });

  const toggleExpand = (label) => {
    setExpanded((prev) => (prev === label ? null : label));
  };

  const navigationItems = [
    {
      label: "Dashboard",
      icon: dashboard,
      activeIcon: dashboardActive,
      link: "/dashboard",
    },
    {
      label: "Customers",
      icon: customer,
      activeIcon: customersActive,
      link: "/customers",
    },
    {
      label: "Hosting Plan",
      icon: plans,
      activeIcon: plansActive,
      link: "/plans",
    },
    {
      label: "Themes",
      icon: themes,
      activeIcon: themesActive,
      link: "/theme",
    },
    // {
    //   label: "Domain",
    //   icon: domain,
    //   activeIcon: domain,
    //   link: "/domain",
    // },
    // {
    //   label: "Content",
    //   icon: content,
    //   activeIcon: contentActive,
    //   link: "",
    //   children: [
    //     { label: "Home", link: `/content/home/:id` },
    //     { label: "About Us", link: "/content/about-us" },
    //     { label: "Features", link: "/content/features" },
    //     { label: "Contact Us", link: "/content/contact-us" },
    //     { label: "Footer", link: "/content/footer" },
    //   ],
    // },
    {
      label: "Payment",
      icon: payment,
      activeIcon: paymentActive,
      link: "/payment",
    },
    {
      label: "Customer Queries",
      icon: payment,
      activeIcon: paymentActive,
      link: "/customer-queries",
    },
  ];
  if (contentNavigation?.children?.length > 0) {
    navigationItems.push(contentNavigation);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        anchor={"left"} // 👈 dynamic
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
        open
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "80px",
            }}
          >
            <img
              src={appLogo}
              alt="App Logo"
              style={{ maxHeight: 50, objectFit: "contain" }}
            />
          </Box>
          <List>
            {[...navigationItems].map((item) => (
              <React.Fragment key={item.label}>
                <ListItem
                  button
                  component={Link}
                  to={item.link}
                  onClick={() =>
                    setActiveItem({ parent: item.label, child: null })
                  }
                  sx={{
                    color:
                      activeItem.parent === item.label ? "#3173B1" : "#868686",
                    fontSize: "20px",
                    fontFamily:
                      activeItem.parent === item.label
                        ? "Tajawal-Bold"
                        : "Tajawal-Regular",
                  }}
                >
                  <img
                    src={
                      activeItem.parent === item.label
                        ? item.activeIcon
                        : item.icon
                    }
                    alt={item.label}
                    style={{ marginRight: 10 }}
                  />
                  <ListItemText primary={item.label} />
                  {item.children &&
                    (expanded === item.label ? (
                      <ExpandLess onClick={() => toggleExpand(item.label)} />
                    ) : (
                      <ExpandMore onClick={() => toggleExpand(item.label)} />
                    ))}
                </ListItem>
                {item.children && (
                  <Collapse
                    in={expanded === item.label}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List component="div" disablePadding>
                      {item.children.map((child) => (
                        <ListItem
                          button
                          component={Link}
                          to={child.link}
                          key={child.label}
                          onClick={() =>
                            setActiveItem({
                              parent: item.label,
                              child: child.label,
                            })
                          }
                          sx={{
                            pl: 4,
                            color:
                              activeItem.child === child.label
                                ? "#3173B1"
                                : "#868686",
                            fontSize: "16px",
                            fontFamily:
                              activeItem.child === child.label
                                ? "Tajawal-Bold"
                                : "Tajawal-Regular",
                          }}
                        >
                          <ListItemText primary={child.label} />
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                )}
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default Sidebar;
